module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content loading-back",
    attrs: {
      "id": "iframe"
    }
  }, [_c('iframe', {
    attrs: {
      "id": "MainPageFrame",
      "name": "NetFrame",
      "height": "100%",
      "width": "100%",
      "frameborder": "0",
      "scrolling": "no",
      "src": _vm.getModule()
    },
    on: {
      "load": _vm.updateHash
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69db3d28","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegacyContainer/index.vue
// module id = tkw6
// module chunks = 13 14